<div class="search" style="justify-content: space-between;">
    <div class="search-input-icon">
        <div class="search-input"><i class="flaticon-search"></i></div>
        <input type='text' [placeholder]='"Search saved reports..."' (keyup)='searchReports()' [(ngModel)]="searchText" class="searchtext"/>
    </div>
</div>

<br>

<ngx-spinner
    bdColor="rgba(75, 55, 100, 0.5)"
    size="large"
    color="#fff"
    type="line-scale-pulse-out">
        <span class="chevron left"></span>
        <span class="chevron right"></span>
  </ngx-spinner>

<ngx-datatable 
    #packageTable 
    class='material striped datatable' 
    [rows]='filteredReports' 
    [columnMode]='"force"'
    [headerHeight]='40' 
    [footerHeight]="20"
    [virtualization]="false"
    [scrollbarV]="true"
    [scrollbarH]="true"
    [rowHeight]="40"
    [reorderable]="true"
>

    <ngx-datatable-column prop="name" [sortable]="true" width="200">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()">
                Name
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.name  }}
        </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column prop="dateSaved" [sortable]="true" width="200">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()">
                Date Saved
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.dateSaved | date:'M/d/yyyy'  }}
        </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column prop="reportType" [sortable]="true" width="200">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()">
                Report Type
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            {{ reportService.getReportTypeDescription(row.reportType) }}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="breakdownType" [sortable]="true" width="200">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()">
                Breakdown Type
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            {{ reportService.getBreakdownDescription(row.breakdownType) }}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column width="250">
        <ng-template let-row="row" ngx-datatable-cell-template>
            <button (click)="viewReport(row)">View</button>
        </ng-template>
    </ngx-datatable-column>

</ngx-datatable>